import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Button
} from "@mui/material";

import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet-async";

import { FiChevronDown } from "react-icons/fi";

import useStyles from "./styles";
import TextInput from "Components/TextInput";
import Spinner from "Components/Spinner";
import { CEP } from "Components/NumberFormat";

import actions from "store/actions";

import { MeiCreateState } from "store/reducers/mei/create";

import ls from "Localization";
import { State } from "store/reducers";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import AutoComplete from "Components/AutoComplete";
import Select from "Components/Select";
import { MeiLogisticOperatorStatus } from "Types/IMei";

let debounceFindLogisticOperator: (() => any) & _.Cancelable;

function MeiCreate() {
	const navigate = useNavigate();
	const dispatch = useDispatch<any>();
	const classes = useStyles({});

	useEffect(() => {
		dispatch(actions.mei.create.clearValues());
	}, [dispatch]);

	const [showInfoPanel, setShowInfoPanel] = useState(true);

	const { loading, errors, businessName, cnpj, type, logisticOperatorStatus } =
		useSelector<State, MeiCreateState>(s => s.meiCreate);

	const findLogisticOperator = (name: any, callback: any) => {
		if (name.length >= 3) {
			if (debounceFindLogisticOperator) debounceFindLogisticOperator.cancel();

			debounceFindLogisticOperator = _.debounce(() => {
				dispatch(
					actions.mei.getMeis(
						0,
						10,
						`&filters[searchText]=${name}&filters[type]=1`,
						undefined,
						false,
						false,
						(errors, models) => {
							if (models) {
								callback(
									models.map(c => ({
										id: c._id,
										label: `${c.businessName}`
									}))
								);
							} else {
								callback([]);
							}
						}
					)
				);
			}, 1000);

			debounceFindLogisticOperator();
		}
	};

	const handleChange = (id: string, value: any) => {
		const v = { [id]: value };

		dispatch(actions.mei.create.setValue(v));
	};

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		dispatch(
			actions.mei.create.createMei(err => {
				if (err) {
					console.log(err);
					if (err.code) {
						alert(err.code);
					} else if (typeof err === "string") alert(err);
					else alert(JSON.stringify(err));
				} else {
					navigate("/Dashboard/Mei");
				}
			})
		);
	};

	return (
		<form onSubmit={handleSubmit} noValidate>
			<Helmet>
				<title>
					{ls.meiCreate} | {ls.appName}
				</title>
			</Helmet>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Accordion
						TransitionProps={{ unmountOnExit: true }}
						expanded={showInfoPanel}
						onChange={() => setShowInfoPanel(prev => !prev)}
					>
						<AccordionSummary
							expandIcon={<FiChevronDown />}
							aria-controls="finishes-content"
							id="finishes-header"
						>
							<Typography className={classes.heading} variant="h6">
								{ls.meiCreate}
							</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="businessName"
										name="businessName"
										value={businessName}
										required
										onChange={handleChange}
									/>
								</Grid>

								<Grid item xs={12} sm={6} md={4} lg={3}>
									<TextInput
										errors={errors}
										id="cnpj"
										name="cnpj"
										value={cnpj}
										required
										onChange={handleChange}
									/>
								</Grid>

								{Number(type) === 0 && (
									<>
										<Grid item xs={12} sm={6} md={4} lg={3}>
											<AutoComplete
												id="logisticOperator"
												name="logisticOperator"
												errors={errors}
												onChange={handleChange}
												loadOptions={findLogisticOperator}
												loading={loading}
												filterOptions={(options: any, state: any) => {
													return options;
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} md={4} lg={3}>
											<Select
												errors={errors}
												id="logisticOperatorStatus"
												name="logisticOperatorStatus"
												value={logisticOperatorStatus?.toString() || ""}
												onChange={handleChange}
												options={Object.values(MeiLogisticOperatorStatus)
													.filter(c => !isNaN(Number(c)))
													.map(c => ({
														id: c,
														value: ls[MeiLogisticOperatorStatus[c]]
													}))}
											/>
										</Grid>
									</>
								)}

								{/* <Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="zipCode"
										name="zipCode"
										InputProps={{
											inputComponent: CEP
										}}
										value={zipCode}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={8}>
									<TextInput
										errors={errors}
										id="street"
										name="street"
										value={street}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="number"
										name="number"
										value={number}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="complement"
										name="complement"
										value={complement}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} lg={4}>
									<TextInput
										errors={errors}
										id="neighborhood"
										name="neighborhood"
										value={neighborhood}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} lg={4}>
									<TextInput
										errors={errors}
										id="city"
										name="city"
										required
										value={city}
										onChange={handleChange}
									/>
								</Grid>
								<Grid item xs={12} sm={6} md={4} lg={2}>
									<TextInput
										errors={errors}
										id="state"
										name="state"
										required
										inputProps={{
											maxLength: 2
										}}
										value={state}
										onChange={handleChange}
									/>
								</Grid> */}
							</Grid>
						</AccordionDetails>
					</Accordion>
				</Grid>

				<Grid item xs={12}>
					<Grid container justifyContent="flex-end">
						<Grid item>
							<Button
								disabled={loading}
								variant="contained"
								color="secondary"
								type="submit"
							>
								Salvar
								{loading && <Spinner size={20} style={{ marginLeft: 16 }} />}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</form>
	);
}

export default MeiCreate;
